<h1 mat-dialog-title>Edit User Email</h1>
<div mat-dialog-content>
  <div class="current-email">
    <span
      >Current email: <strong>{{ currentEmail }}</strong></span
    >
    <mat-chip-listbox>
      <mat-chip [color]="emailVerified ? 'primary' : 'warn'" selected>
        {{ emailVerified ? 'Verified' : 'Not Verified' }}
      </mat-chip>
    </mat-chip-listbox>
  </div>

  <form class="form" [formGroup]="form">
    <mat-form-field class="fullwidth">
      <mat-label>New Email Address</mat-label>
      <input matInput formControlName="newEmail" placeholder="new@example.com" />
      <mat-error *ngIf="form.get('newEmail')?.hasError('required')">Email is required</mat-error>
      <mat-error *ngIf="form.get('newEmail')?.hasError('email')"
        >Enter a valid email address</mat-error
      >
    </mat-form-field>
  </form>

  <div class="verify-actions-container">
    <div *ngIf="!emailVerified" class="verify-actions">
      <button mat-raised-button color="accent" (click)="verifyEmail()">Verify User</button>
      <button mat-raised-button color="accent" (click)="forceVerifyEmail()">Force Verify</button>
    </div>
    <div *ngIf="emailVerified" class="verify-actions">
      <mat-icon color="primary">check_circle</mat-icon>
      <span>Email is verified</span>
    </div>
  </div>
</div>
<div class="buttons" mat-dialog-actions>
  <button
    mat-raised-button
    color="primary"
    class="primarybutton"
    [disabled]="saving || form.invalid"
    (click)="saveEmail()"
  >
    {{ saving ? 'Saving...' : 'Change Email' }}
  </button>
  <button mat-raised-button (click)="onDismiss()">Cancel</button>
</div>
